import { render, staticRenderFns } from "./DeclareApplyList.vue?vue&type=template&id=4a45e603&scoped=true&"
import script from "./DeclareApplyList.vue?vue&type=script&lang=js&"
export * from "./DeclareApplyList.vue?vue&type=script&lang=js&"
import style0 from "./DeclareApplyList.vue?vue&type=style&index=0&id=4a45e603&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45e603",
  null
  
)

export default component.exports